<template>
  <el-dialog width="480px" class="dialog" title="订单改派" :visible.sync="dialogFormVisible">
    <el-form ref="ruleForm" label-position="right" :rules="rules" :model="formData" label-width="120px">
      <el-form-item label="下派师傅" prop="engineerId">
        <el-select v-model="formData.engineerId" placeholder="请选择需要下派的师傅">
          <el-option v-for="item in masterList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      /**
       * dialogFormVisible 弹框状态
       * formData 表单数据
       * rules 表单规则
       */
      dialogFormVisible: false,
      formData: {

      },
      rules: {
        engineerId: [
          { required: true, message: '请选择需要下派的师傅', trigger: 'blur' },
        ]
      },
      masterList: [],
      btnLoading: false
    }
  },
  methods: {
    // 关闭弹框
    closeDialog () {
      this.dialogFormVisible = false
    },
    // 打开弹框
    openDialog (orderNums) {
      this.getList()
      this.formData.orderNums = orderNums
      this.dialogFormVisible = true
    },
    // 确认提交
    submitBtnFun () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          this.submitReq()
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 表单重置
    resetFormStatus () {
      this.$refs.ruleForm.resetFields()
    },
    // 获取数据请求
    getList () {
      const url = '/autoapp-default-server-recovery/api/tbl-recycel-engineer/list'
      this.HttpService.post(url, {}).then(res => {
        if (res.statusCode === 200) {
          if (res.data.length !== 0) {
            res.data = res.data.filter(item => item.state === 1)
          }
          this.masterList = res.data || []
        }
      })
    },
    // 请求提交
    submitReq () {
      const url = `/autoapp-default-server-recovery/api/tblRecycleOrder/batchDispatch`
      this.HttpService.post(url, this.formData).then(res => {
        this.btnLoading = false
        if (res.statusCode === 200) {
          this.$message.success('改派成功')
          this.$emit('opera-success')
          this.resetFormStatus()
          this.closeDialog()
        } else {
          const tipMsg = res.message || '改派失败'
          this.$message.error(tipMsg)
        }
      })
    },
  }
}
</script>
<style scoped lang='scss'>
.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/OrderReassign.vue